import React, { useEffect, useRef } from "react";
import $ from "jquery";
import "datatables.net-bs4"; // or "datatables.net" for custom styling
import { Link } from "react-router-dom";
import ConfirmModal from "../../Components/ConfirmModal/ConfirmModal";
import FiltersBox from "../../Components/FiltersModal/FiltersBox";
import ContentHeader from "../../Components/ContentHeader/ContentHeader";
import Loading from "../../Components/Loading/Loading";
import Table from "../../Components/Table/Table";
import Search from "../../Components/Search/Search";
import CustomToast from "../../Components/CustomToast/CustomToast";
import DashBoardFilters from "../../Components/DashBoardFilters/DashBoardFilters";

function ECAAuditsListUi({
  columns,
  data,
  tableQaury,
  onPageChange,
  totalRecords,
  loading,
  deleteAuditFn,
  setTableQaury,
  selectData,
  setFiltersId,
  refetchStates,
  refetchcity,
  setSelectData,
  filtersId,
  applyFilter,
  removeFilter,
  decodedToken,
  toast,
  selectedCENd
}) {  
  const totalPages = Math.ceil(totalRecords / tableQaury?.rowsPerPage);
  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <>
          {/* Content Wrapper. Contains page content */}
          <div className="content-wrapper">
            {/* Content Header (Page header) */}

            <ContentHeader
              title={"Audits"}
              buttonName={""}
              buttonBoolean={false}
              pageName={""}
              linkPath={""}
            />

            {/* Main content */}
            <section className="content">
              <div className="container-fluid">
                {/* {selectedCENd ? */}
              {/* <div className="dash-card mb-3">
                      <DashBoardFilters
                        // cenData={cenData}
                        setFiltersId={setFiltersId}
                        refetchStates={refetchStates}
                        refetchcity={refetchcity}
                        setSelectData={setSelectData}
                        filtersId={filtersId}
                        applyFilter={applyFilter}
                        removeFilter={removeFilter}
                        decodedToken={decodedToken}
                        showFilter={{
                          cen: false,
                          button: false
                        }}
                      />
                                       </div>  */}
                                       {/* :null} */}
                {/* <div>
                  <FiltersBox
                    selectData={selectData}
                    setFiltersId={setFiltersId}
                    refetchStates={refetchStates}
                    refetchcity={refetchcity}
                    setSelectData={setSelectData}
                    filtersId={filtersId}
                    applyFilter={applyFilter}
                    removeFilter={removeFilter}
                    decodedToken={decodedToken}
                  />
                </div> */}
                <div className="row">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                      {toast && (
                          <CustomToast
                            text={toast?.message}
                            type={toast?.type}
                          />
                        )}
                        <div className="mb-3">
                        <DashBoardFilters
                        // cenData={cenData}
                        setFiltersId={setFiltersId}
                        refetchStates={refetchStates}
                        refetchcity={refetchcity}
                        setSelectData={setSelectData}
                        filtersId={filtersId}
                        applyFilter={applyFilter}
                        removeFilter={removeFilter}
                        decodedToken={decodedToken}
                        showFilter={{
                          cen: false,
                          button: false
                        }}
                      />
                        </div>
                      {/* <Search setTableQaury={setTableQaury} tableQaury={tableQaury} placeHolder={"Search By Name"}/> */}
                        <Table
                          columns={columns}
                          data={data}
                          pagination={totalPages}
                          onPageChange={onPageChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </>
      )}

      <ConfirmModal
        confirmFn={deleteAuditFn}
        text={"Are you sure,You want to Cancel Audit  ?"}
        buttonText={"Delete"}
      />
    </div>
  );
}

export default ECAAuditsListUi;
